import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { setCategoryId } from '../../actions/products'

import Stations from './Stations/Stations';
import CustomerScreen from './CustomerScreen/CustomerScreen';
import StoreSettings from './StoreSettings/StoreSettings';
import LayoutSettings from './LayoutSettings/LayoutSettings';
import IntegrationsSettings from './IntegrationsSettings/IntegrationsSettings';
import SystemSettings from './SystemSettings/SystemSettings';
import PayrollSettings from './PayrollSettings/PayrollSettings';
import PayoutSettings from './PayoutSettings/PayoutSettings';

import Loader from '../../components/Loader/Loader';
import { withTranslation } from '../../i18n/LanguageContext';
import {
    buildAuthRoleState,
    canAccessFullSettingsTabs,
    canAccessPayoutPage,
    canAccessPayoutSettings,
    PORTAL_PAYOUT_PATH,
} from '../../actions/auth';

class Settings extends React.Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    render() {
        const { pathname } = this.props.location;
        const { t } = this.props;

        const {
            isReceiving,
            isUpdating,
            isDeleting,
            identityRolesLoaded,
            canViewPayoutSettings,
            canViewPayoutPage,
            canViewFullSettingsTabs,
            portalDefaultPath,
        } = this.props;
        const showPayoutTab = identityRolesLoaded && canViewPayoutPage;
        const showFullSettingsTabs = identityRolesLoaded && canViewFullSettingsTabs;
        const settingsDefaultPath = showPayoutTab && !showFullSettingsTabs
            ? PORTAL_PAYOUT_PATH
            : '/admin/settings/store_settings';

        return (
            <div className="page-wrapper">
                <div className="page-tabs">
                    {showFullSettingsTabs ? (
                        <>
                            <Link 
                                className={`page-tab ${pathname.startsWith('/admin/settings/store_settings') ? 'page-tab--active' : ''}`} 
                                to="/admin/settings/store_settings"
                            >
                                <i className="zmdi zmdi-store"></i>
                                <span>{t('settingsTabs.store')}</span>
                            </Link>
                            <Link 
                                className={`page-tab ${pathname.startsWith('/admin/settings/stations') ? 'page-tab--active' : ''}`} 
                                to="/admin/settings/stations"
                            >
                                <i className="zmdi zmdi-devices"></i>
                                <span>{t('settingsTabs.stations')}</span>
                            </Link>
                            <Link 
                                className={`page-tab ${pathname.startsWith('/admin/settings/customer_screen') ? 'page-tab--active' : ''}`} 
                                to="/admin/settings/customer_screen"
                            >
                                <i className="zmdi zmdi-tv"></i>
                                <span>{t('settingsTabs.customerScreen')}</span>
                            </Link>
                            <Link
                                className={`page-tab ${pathname.startsWith('/admin/settings/layouts') ? 'page-tab--active' : ''}`}
                                to="/admin/settings/layouts"
                            >
                                <i className="zmdi zmdi-grid"></i>
                                <span>{t('settingsTabs.layouts')}</span>
                            </Link>
                            <Link
                                className={`page-tab ${pathname.startsWith('/admin/settings/integrations') ? 'page-tab--active' : ''}`}
                                to="/admin/settings/integrations"
                            >
                                <i className="zmdi zmdi-link"></i>
                                <span>{t('settingsTabs.integrations')}</span>
                            </Link>
                            <Link
                                className={`page-tab ${pathname.startsWith('/admin/settings/system') ? 'page-tab--active' : ''}`}
                                to="/admin/settings/system"
                            >
                                <i className="zmdi zmdi-wrench"></i>
                                <span>{t('settingsTabs.system')}</span>
                            </Link>
                            <Link
                                className={`page-tab ${pathname.startsWith('/admin/settings/payroll') ? 'page-tab--active' : ''}`}
                                to="/admin/settings/payroll"
                            >
                                <i className="zmdi zmdi-accounts-list"></i>
                                <span>{t('settingsTabs.payroll')}</span>
                            </Link>
                        </>
                    ) : null}
                    {showPayoutTab ? (
                        <Link
                            className={`page-tab page-tab--payout ${pathname.startsWith(PORTAL_PAYOUT_PATH) ? 'page-tab--active' : ''}`}
                            to={PORTAL_PAYOUT_PATH}
                        >
                            <i className="zmdi zmdi-money"></i>
                            <span>{t('settingsTabs.payout')}</span>
                        </Link>
                    ) : null}
                </div>
                <div className="page-content">
                    {
                        isReceiving || isUpdating || isDeleting ? (<Loader size={80}/>) : (<div></div>)
                    }
                    <TransitionGroup>
                        <CSSTransition
                        key={this.props.location.key}
                        classNames="fade"
                        timeout={600}
                        >
                        <Switch>
                            <Route path="/admin/settings" exact render={() => <Redirect to={settingsDefaultPath} />} />
                            <Route
                                path="/admin/settings/store_settings"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <StoreSettings />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/stations"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <Stations />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/customer_screen"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <CustomerScreen />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/layouts"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <LayoutSettings />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/integrations"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <IntegrationsSettings />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/system"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <SystemSettings />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/payroll"
                                exact
                                render={() => (
                                    showFullSettingsTabs
                                        ? <PayrollSettings />
                                        : <Redirect to={portalDefaultPath} />
                                )}
                            />
                            <Route
                                path="/admin/settings/admin"
                                exact
                                render={() => {
                                    if (!identityRolesLoaded) {
                                        return null;
                                    }
                                    return canViewPayoutSettings
                                        ? <Redirect to={PORTAL_PAYOUT_PATH} />
                                        : <Redirect to={settingsDefaultPath} />;
                                }}
                            />
                            <Route
                                path={PORTAL_PAYOUT_PATH}
                                exact
                                render={() => {
                                    if (!identityRolesLoaded) {
                                        return <PayoutSettings />;
                                    }
                                    return canViewPayoutPage
                                        ? <PayoutSettings />
                                        : <Redirect to={settingsDefaultPath} />;
                                }}
                            />
                        </Switch>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const authRoleState = buildAuthRoleState(state.auth);

    return {
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
        identityRolesLoaded: authRoleState.identityRolesLoaded,
        identityRoles: authRoleState.identityRoles,
        canViewPayoutSettings: canAccessPayoutSettings(authRoleState),
        canViewPayoutPage: canAccessPayoutPage(authRoleState),
        canViewFullSettingsTabs: authRoleState.canAccessFullSettingsTabs,
        portalDefaultPath: authRoleState.portalDefaultPath,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(Settings)));
